import type { Workspace } from '@/entities/workspace';
import { can, PERMISSIONS } from '@/shared/lib/permissions';

/** May the viewer change the workspace's header color (the same right as renaming it)? */
export const canColorWorkspace = (workspace: Workspace): boolean =>
  can(workspace.permissions, PERMISSIONS.workspaceUpdateSettings);
